import React from 'react';
import { getPersonalInfo, getSocialLinks } from '../utils/contentLoader';

function Footer() {
  const personalInfo = getPersonalInfo();
  const socialLinks = getSocialLinks();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="copyright">
            © {currentYear} {personalInfo.name || 'Personal Website'}. All rights reserved.
          </div>
          
          {Object.keys(socialLinks).length > 0 && (
            <div className="social-links">
              {socialLinks.github && (
                <a href={socialLinks.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                  <i className="fab fa-github"></i>
                </a>
              )}
              {socialLinks.linkedin && (
                <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <i className="fab fa-linkedin"></i>
                </a>
              )}
              {socialLinks.twitter && (
                <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <i className="fab fa-twitter"></i>
                </a>
              )}
              {socialLinks.googleScholar && (
                <a href={socialLinks.googleScholar} target="_blank" rel="noopener noreferrer" aria-label="Google Scholar">
                  <i className="ai ai-google-scholar"></i>
                </a>
              )}
              {socialLinks.orcid && (
                <a href={socialLinks.orcid} target="_blank" rel="noopener noreferrer" aria-label="ORCID">
                  <i className="ai ai-orcid"></i>
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;